// extracted by mini-css-extract-plugin
module.exports = {"cta":"styles_cta__TL0Q3","cta__content":"styles_cta__content__DNSBF","pulse":"styles_pulse__E4ydz","jump":"styles_jump__FJnNf","wiggle":"styles_wiggle__HHG6N"};